export const sylndrDirections =
    'https://goo.gl/maps/Pw9dHb1RG27w7bFQ9?coh=178573&entry=tt';
export const MOBILE_SCREEN_LABEL = 'Mobile';
export const DESKTOP_SCREEN_LABEL = 'Desktop';
export const APP_STORE_LINK = 'https://apps.apple.com/eg/app/id6472655250';
export const GOOGLE_PLAY_LINK =
    'https://play.google.com/store/apps/details?id=com.Sylndr.app';
export const HUAWEI_PLAY_LINK = 'https://appgallery.huawei.com/app/C112534329';
